var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowGoBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.833 9.16643H5.94551L8.97301 5.53309C9.26801 5.17976 9.21967 4.65393 8.86634 4.35976C8.51217 4.06476 7.98717 4.11309 7.69301 4.46643L3.52634 9.46643C3.49384 9.5056 3.47717 9.55143 3.45301 9.59476C3.43301 9.62976 3.40884 9.65976 3.39384 9.69809C3.35634 9.79393 3.33384 9.89476 3.33384 9.99643C3.33384 9.99726 3.33301 9.99893 3.33301 9.99976C3.33301 10.0006 3.33384 10.0023 3.33384 10.0031C3.33384 10.1048 3.35634 10.2056 3.39384 10.3014C3.40884 10.3398 3.43301 10.3698 3.45301 10.4048C3.47717 10.4481 3.49384 10.4939 3.52634 10.5331L7.69301 15.5331C7.85801 15.7306 8.09467 15.8331 8.33301 15.8331C8.52134 15.8331 8.71051 15.7698 8.86634 15.6398C9.21967 15.3456 9.26801 14.8198 8.97301 14.4664L5.94551 10.8331H15.833C16.293 10.8331 16.6663 10.4598 16.6663 9.99976C16.6663 9.53976 16.293 9.16643 15.833 9.16643Z",
    fill: "#394D5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowGoBack);
export default __webpack_public_path__ + "static/media/ArrowGoBack.ec8df15bc2bff87f3803c1a800c34de2.svg";
export { ForwardRef as ReactComponent };